<template>
  <div class="selectcity" :class="{'hashead':!$store.state.isPC}">
    <!-- <Header v-if="$store.state.isPC" :sltCity="true"></Header> -->
    <WapHeader  v-if="!$store.state.isPC" :title="'选择城市'" :showhome="false"></WapHeader>
    <slot v-if="!isPC">
      <div class="search-city"><i class="m-icon mi-search"></i><input type="text" v-model="cityKey" placeholder="输入城市名或简称" @input="cityKeyChange" @focus="cityKey!=''?showCityResult=true:''">
        <div class="search-list" v-show="showCityResult">
          <span v-show="showTips">抱歉，没有找到相关城市</span>
          <p :key="index" v-for="(item,index) in searchCityList" @click="changeCity(item)">{{item.city}}</p>
        </div>
      </div>
      <div id="citywrap">
        <div class="initials" :style="'margin-top:-'+cityItems.length*11+'px'">
          <span :key="indexs" v-for="(items,indexs) in cityItems" @click="letterClick('#' + items.letter)">{{items.letter}}</span>
        </div>
        <div class="refresh">
          <span class="relocation" @click="clickRelocation()"><i class="m-icon mi-refresh"></i>重新定位</span>
        	<span class="cityname">{{lcity}}</span><span class="font"><i class="m-icon mi-sltcity"></i>GPS定位</span>
        </div>
        <div class="hotcity">
        	<p>热门城市</p>
        	<button v-for="(item,index) in storage.get('cityItems')" :key="index" v-if="index<6" @click="changeCity(item)">{{item.city}}</button>
        </div>
        <div class="allcity">
        	<p style="padding:0 0 10px 15px;">所有城市</p>
        	<!-- <ul class="clearfix">
        		<li v-for="(item,index) in cityItems" :key="index" @click="changeCity(item)">{{item.city}}</li>
        	</ul> -->
          <div class="citylist" @click="showCityResult=false">
            <div :key="indexs" v-for="(items,indexs) in cityItems">
              <div class="tag" :id="items.letter">{{items.letter}}</div>
              <p :key="index" v-for="(item,index) in items.data" @click="changeCity(item)">{{item.city}}</p>
            </div>
          </div>
        </div>
        <div class="more">
        	<p>更多城市敬请期待</p>
        </div>
      </div>
    </slot>
    <div class="box" v-else>
      <div class="maintop"><h1>请选择城市</h1>SELECT CITY</div>
      <div class="textcity clearfix">
        <div :key="indexs" v-for="(items,indexs) in cityItems">
          <label class="tag" :id="items.letter">{{items.letter}}</label>
          <span :key="index" v-for="(item,index) in items.data" @click="changeCity(item)">{{item.city}}</span>
        </div>
        <!-- <span v-for="(item,index) in cityItems" :key="index" @click="changeCity(item)">{{item.city}}</span> -->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/public/Header'
import WapHeader from '@/components/public/WapHeader'
import Footer from '@/components/public/Footer'
import pinyin from '../store/pinyin.js';
import domain from '../store/domain.js';
export default {
  name:'City',
  inject:['reload'],
  components:{
    'Header': Header,
    'WapHeader':WapHeader,
    'Footer': Footer,
  },
  data () {
  	return {
      isPC:this.$store.state.isPC,
      cityItems:this.storage.get('cityItems'),
      lcity:'',
      cityKey:'',
      showCityResult:false,
      searchCityList:[],
      showTips:false,
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  mounted(){
    if(this.$route.params.local){
      //this.clickRelocation()
    }
    this.cityItems=pinyin.pySegSort(this.cityItems);
  },
  methods:{
    cityKeyChange(){
      this.searchCityList=[];
      if(this.cityKey!=''){
        this.searchCityList=pinyin.searchResult(this.storage.get('cityItems'),this.cityKey);
        if(this.searchCityList.length==0){
          this.showTips=true
        }else{
          this.showTips=false;
          this.searchCityList.sort(pinyin.sortCity)
        }
        this.showCityResult=true
      }else{
        this.showCityResult=false
      }
    },
    letterClick(id){
      document.querySelector('.selectcity').scrollTop = this.$el.querySelector(id).offsetTop-11;
    },
  	//改变选中城市
  	changeCity:function(city){
      this.storage.set('city',city);
      domain.change(city.cityCode);
    },
    //重新定位，获取当前城市id
    clickRelocation:function(){  
      const geolocation = new BMap.Geolocation();
      var _this = this
      _this.lcity = '';
      geolocation.getCurrentPosition(function getinfo(position){
          let city = position.address.city;            //获取城市信息
          let province = position.address.province;    //获取省份信息
          _this.LocationCity = city
          if(_this.LocationCity.endsWith('市')){
            _this.LocationCity=_this.LocationCity.substring(0, _this.LocationCity.lastIndexOf('市'));
          }
          _this.lcity = _this.LocationCity;
          for (let i in _this.cityItems) {
            if(_this.cityItems[i].city == _this.LocationCity){
              _this.storage.set('city',_this.cityItems[i]);
               _this.storage.set('cityCode',_this.cityItems[i].cityCode);
              _this.changeCity(_this.cityItems[i]);
            }
          }
      }, function(e) {
          _this.LocationCity = "定位失败"
      }, {provider: 'baidu'});
    },
  }
}
</script>


<style scoped lang="less">
.citylist{
    p{display:inline-block;line-height:25px;color:#555;width:30%;text-align:center;margin-bottom:10px;}
    .tag{font-size:12px;color:#888;line-height:25px;padding:0 15px;background:#f2f2f2;margin-bottom:10px;}
  }
.initials{position:fixed;right:0;top:50%;text-align:center;z-index:1;
  span{display:block;line-height:22px;font-size:12px;color:#333;width:40px;text-align:center;}
}
.search-city{position:fixed;left:0;top:46px;right:0;background:#fff;z-index:8;padding:0 15px 10px;
  input{line-height:38px;height:40px;border:0;display:block;width:100%;border:1px solid rgba(0,0,0,0.1);font-size:15px;padding:0 15px 0 45px;box-sizing:border-box;border-radius:20px;}
  .mi-search{position:absolute;left:32px;top:11px;background-position:0 0;width:17px;height:17px;}
  .search-list{position:absolute;left:15px;right:15px;top:45px;background:#fff;padding:10px 15px;z-index:9;box-shadow:0 1px 3px rgba(0,0,0,0.2);max-height:340px;overflow:auto;
    p,span{display:block;line-height:34px;}
    span{color:#999;text-align:center;}
  }
}
#citywrap{position:relative;}
.selectcity{color:#666;line-height:20px;padding-top:85px;background:#fff;position:fixed;left:0;right:0;top:0;bottom:0;overflow:auto;}
.cityname{font-size:16px;color:#000;font-weight:700;margin-left:15px;}
.refresh{background:#fff;height:35px;font-size:13px;padding:15px 0 0;}
.refresh span{vertical-align:top;display:inline-block;}
.mi-sltcity{background-position:-45px 0;margin-right:4px;width:13px;height:15px;margin-left:10px;margin-top:-1px;}
.mi-refresh{background-position:-107px 0;margin-right:4px;width:11px;height:11px;margin-top:1px;margin-left:10px;}
.relocation{float:right;margin-right:40px;}
.hotcity{padding:0 40px 15px 15px;}
.hotcity button{line-height:32px;background:#fff;border:1px solid #ddd;border-radius:20px;color:#444;margin-top:10px;width:31%;margin-left:3.5%;}
.hotcity button:nth-child(2),.hotcity button:nth-child(5){margin-left:0;}
.allcity{padding-top:10px;}
// .allcity p{padding-left:20px;margin-bottom:10px;}
// .allcity ul{background:#fff;}
// .allcity li{line-height:40px;padding:0 20px;color:#444;}
// .allcity li+li{border-top:1px solid #eee;}
.more{padding:10px;background:#f2f2f2;text-align:center;margin-bottom:-10px}
@media (min-width:769px){
  .box{text-align:center;padding:40px 0 25px;color:#656565;line-height:20px;}
  h1{font-size:34px;line-height:60px;color:#3a3935;letter-spacing:2px;}
  .textcity{width:60%;margin:30px auto 0;text-align:left;line-height:30px;}
  .textcity div{margin-bottom:10px;position:relative;}
  .textcity label{position:absolute;left:-30px;top:5px;line-height:30px;color:#999;font-size:20px;}
  .textcity span{cursor:pointer;color:#656565;width:60px;display:inline-block;border-radius:2px;margin:5px 5px 0;text-align:center;}
  .textcity span:hover{background:#ffd03d;color:#333;}
  .selectcity{padding-top:0;}
}
</style>


// WEBPACK FOOTER //
// src/components/City.vue